import React, { useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { MdOutlineEmail, MdOutlineLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import logo from "../../../assets/images/Header/logo.png";

const Login = () => {
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(form.email, form.password);
            navigate("/dashboard");
        } catch (err) {
            setError(err.response?.data?.message || "Login failed");
        }
    };

    return (
        <section className="login-page" aria-label="Login page">
            <div className="login-shell">
                <aside className="login-visual">
                    <div className="login-brand-mark">
                        <img src={logo} alt="Offshore Advisory logo" className="login-brand-logo" />
                    </div>
                    <p className="login-kicker">Offshore Advisory</p>
                    <h1 className="login-heading">Admin Dashboard</h1>
                </aside>

                <div className="login-card">
                    <div className="login-card-header">
                        <h2 className="login-title">Welcome back</h2>
                        <p className="login-subtitle">Enter your credentials to continue.</p>
                    </div>

                    <form className="login-form" onSubmit={handleSubmit}>
                        <div className="login-field">
                            <label className="login-label" htmlFor="email">Email</label>
                            <div className="login-input-wrap">
                                <MdOutlineEmail className="login-field-icon" aria-hidden="true" />
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                    className="login-input"
                                    placeholder="name@company.com"
                                    autoComplete="email"
                                />
                            </div>
                        </div>

                        <div className="login-field">
                            <label className="login-label" htmlFor="password">Password</label>
                            <div className="login-input-wrap">
                                <MdOutlineLock className="login-field-icon" aria-hidden="true" />
                                <input
                                    id="password"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    value={form.password}
                                    onChange={handleChange}
                                    required
                                    className="login-input"
                                    placeholder="Enter your password"
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    className="login-toggle"
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <MdVisibilityOff aria-hidden="true" /> : <MdVisibility aria-hidden="true" />}
                                </button>
                            </div>
                        </div>

                        {error && <p className="login-error">{error}</p>}

                        <button type="submit" className="login-button">
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Login;
